import { NavLink } from 'react-router-dom';
import { ArrowDownIcon } from '../assets/svgImages';
import { NavItemProps } from '../interface/interface';

const NavItem: React.FC<NavItemProps> = ({
  element,
  cartCount,
  onClick,
  isDropdownOpen,
  isActive,
}) => {
  return (
    <NavLink
      to={element.href}
      key={element.name}
      className="flex flex-col items-center relative"
      id={element.name}
      onClick={onClick}
    >
      <img className="w-6 h-6" src={element.mobileNavIcon} alt={element.name} />

      {element.href === '/cart' && cartCount ? (
        <span className="bg-primary-red-300 text-xs rounded-full py-1.5 px-3 absolute -top-3.5 -right-5 z-10">
          {cartCount}
        </span>
      ) : null}

      <p
        className={`${
          isActive
            ? 'active border-b-4 border-solid border-secondary-pink-500'
            : ''
        } text-xs text-primary-blue-500 font-regular pt-3 flex items-center
        `}
      >
        {element.mobileName}
        {element.subNav ? (
          <ArrowDownIcon
            className={`${
              isDropdownOpen ? 'rotate-180' : 'rotate-0'
            } h-2 w-2 fill-primary-blue-500 ml-1.5`}
          />
        ) : null}
      </p>
    </NavLink>
  );
};

export default NavItem;
